<template>
  <div class="users">
    <modal :title="title" v-if="modal" @close="switchModal">
      <user-binds v-if="bindsEdit" @close="switchModal" :data="editableUser"/>
      <user v-else @close="switchModal" :data="editableUser"/>
    </modal>
    <ccs-header
      :title="'Пользователи'"
      :info="false" nightTheme/>
    <div class="users-content">
      <div class="users-actions">
        <button v-if="permissionsStatus.isUserCreateAllowed"
          class="ccs-button" @click="switchModal">
          Добавить пользователя
        </button>
      </div>
      <ccs-table :data="users" :columnsDefs="columnsDefs" :options="tableOptions">
        <template v-slot:role="props">
          {{ props.isEmpty ? 'Роль отсутствует' : props.row.roles[0].name }}
        </template>
        <template v-slot:actions="props">
          <v-icon v-if="permissionsStatus.isUserUpdateAllowed"
            class="ccs-icon--primary ccs-icon--hover" name="cog"
            @click="switchModal(props.row, true)"/>
          <v-icon v-if="permissionsStatus.isUserUpdateAllowed"
            class="ccs-icon--primary ccs-icon--hover" name="edit"
            @click="switchModal(props.row)"/>
          <v-icon v-if="permissionsStatus.isUserDeleteAllowed"
            class="ccs-icon--secondary ccs-icon--hover"
            name="trash" scale="0.9"
            @click="removeUser(props.row)"/>
        </template>
      </ccs-table>
      <pagination :dataFunction="getUsers" nightTheme/>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import Header from '@/layouts/Header.vue';
import Table from '@/components/Table.vue';
import Modal from '@/components/Modal.vue';
import Pagination from '@/components/Pagination.vue';

import User from '@/components/modals/users/User.vue';
import UserBinds from '@/components/modals/users/UserBinds.vue';

export default {
  name: 'Users',
  components: {
    'ccs-header': Header,
    'ccs-table': Table,
    Modal,
    User,
    UserBinds,
    Pagination,
  },
  data() {
    return {
      modal: false,
      bindsEdit: false,
      editableUser: null,
      titles: {
        new: 'Новый пользователь',
        edit: 'Редактирование пользователя',
      },
      columnsDefs: [{
        name: `full_name`,
        title: 'ФИО',
        prop: 'full_name',
        type: 'text',
      }, {
        name: `role`,
        title: `Роль`,
        prop: `roles`,
        fontStyle: 'secondary',
        type: 'text',
      }, {
        name: `email`,
        title: `Email`,
        prop: `email`,
      }, {
        name: `actions`,
        title: `Действия`,
        prop: `id`,
        isActions: true,
      }],
      tableOptions: {
        hideBottomBorder: true,
        nightTheme: true,
      },
    };
  },
  computed: {
    ...mapState('users', ['users']),
    ...mapGetters('session', ['permissionsStatus']),
    title() {
      return this.editableUser ? this.titles.edit : this.titles.new;
    },
  },
  methods: {
    ...mapActions('users', ['getUsers', 'updateUser', 'deleteUser']),
    switchModal(editableUser = null, bindsEdit = false) {
      this.modal = !this.modal;
      this.bindsEdit = bindsEdit;
      this.editableUser = !editableUser ? editableUser : Object.assign({}, editableUser);
    },
    async removeUser(user) {
      try {
        await this.deleteUser(user.id);
        this.$toasted.success('Пользователь удалён');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.users {
  min-height: 100%;
  min-width: 100%;
  background: $surfaceDarker;

  &-content {
    margin: 0 33px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }

  &-actions {
    margin-bottom: 20px;
  }

}
</style>
